import React from "react";
import { statusClass, titleCase } from "../lib/format";
export default function StatusBadge({ status }) {
  return <span className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold ${statusClass(status)}`} data-testid={`status-${status}`}>{titleCase(status)}</span>;
}
